import { useMediaQuery } from '@mui/material';

import { OSelect, OSwitch, OTooltip } from '@src/shared';
import { SYSTEM_LANGUAGES, SYSTEM_THEMES } from '@src/constants';
import { EMainConfigKeys, EChatConfigKeys, ECalculatorConfigKeys } from '@src/types';
import { useTheme } from '@src/contexts/ThemeContext';
import useGeneralSettings from './useGeneralSettings';

const GeneralSettings = () => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const { theme, setTheme } = useTheme(); // Get theme and setTheme from context

  const handleThemeChange = (selectedValue: string) => {
    setTheme(selectedValue as 'light' | 'dark');
  };

  const { userTypeRoomConfig, canUserManageSettings, handleToggleChange } = useGeneralSettings();

  return (
    <div className="settings-body-container">
      <OSelect
        items={SYSTEM_LANGUAGES}
        onChange={() => {}}
        classes={{
          selectContainer: 'settings-select',
        }}
        selectedValue={SYSTEM_LANGUAGES[0].value}
        label="Language"
        alignItems="start"
        size={isMobile ? 'medium' : 'large'}
      />
      <OSelect
        items={SYSTEM_THEMES}
        onChange={(value) => handleThemeChange(value)}
        classes={{
          selectContainer: 'settings-select',
        }}
        selectedValue={theme}
        label="Theme"
        alignItems="start"
        size={isMobile ? 'medium' : 'large'}
      />

      {canUserManageSettings && (
        <>
          <div className="chat-container">
            <OSwitch
              sectionTitle="Chat"
              label="Enable public chat"
              size={isMobile ? 'medium' : 'large'}
              isChecked={userTypeRoomConfig.main.chatButton}
              onChange={(checked) => {
                handleToggleChange(EMainConfigKeys.ChatButton, checked);
              }}
              classes={{
                label: 'chat-item-top',
              }}
              id="settings_public_chat"
            />

            <OTooltip title={userTypeRoomConfig.main.chatButton ? '' : 'Enable public chat first.'}>
              <div>
                <OSwitch
                  label="Enable private chat"
                  size={isMobile ? 'medium' : 'large'}
                  isChecked={userTypeRoomConfig.chat.privateChatButton}
                  onChange={(checked) => handleToggleChange(EChatConfigKeys.PrivateChatButton, checked)}
                  isDisabled={!userTypeRoomConfig.main.chatButton}
                  classes={{
                    label: 'chat-item-bottom',
                  }}
                  id="settings_private_chat"
                />
              </div>
            </OTooltip>
          </div>

          <OSwitch
            sectionTitle="Polls"
            label="Enable polls"
            size={isMobile ? 'medium' : 'large'}
            isChecked={userTypeRoomConfig.main.pollButton}
            onChange={(checked) => handleToggleChange(EMainConfigKeys.PollButton, checked)}
            id="settings_polls"
          />

          <OSwitch
            sectionTitle="Share screen"
            label="Allow anyone to share screen"
            size={isMobile ? 'medium' : 'large'}
            isChecked={userTypeRoomConfig.main.startScreenButton}
            onChange={(checked) => handleToggleChange(EMainConfigKeys.StartScreenButton, checked)}
            id="settings_share_screen"
          />

          <div className="calculator-container">
            <OSwitch
              sectionTitle="Share Calculator"
              label="Allow participants to use Calculator"
              size={isMobile ? 'medium' : 'large'}
              isChecked={userTypeRoomConfig.calculator.calculatorShowButton}
              onChange={(checked) => {
                handleToggleChange(ECalculatorConfigKeys.calculatorShowButton, checked);
              }}
              classes={{
                label: 'calculator-item-top',
              }}
              id="settings_calculator_visibility"
            />

            <OTooltip title={userTypeRoomConfig.calculator.calculatorShowButton ? '' : 'Enable calculator first.'}>
              <div>
                <OSwitch
                  label="Allow anyone to share calculator"
                  size={isMobile ? 'medium' : 'large'}
                  isChecked={userTypeRoomConfig.calculator.shareCalculatorButton}
                  onChange={(checked) => handleToggleChange(ECalculatorConfigKeys.shareCalculatorButton, checked)}
                  isDisabled={!userTypeRoomConfig.calculator.calculatorShowButton}
                  classes={{
                    label: 'calculator-item-bottom',
                  }}
                  id="settings_calculator_share"
                />
              </div>
            </OTooltip>
          </div>
        </>
      )}
    </div>
  );
};

export default GeneralSettings;
